document.addEventListener("DOMContentLoaded", function () {
  const currencyRegex = /\bNIS\b/g;

  // Safe patch for Shopify.formatMoney
  if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
    const originalFormatMoney = Shopify.formatMoney;
    Shopify.formatMoney = function () {
      const result = originalFormatMoney.apply(this, arguments);
      return typeof result === 'string' ? result.replace(currencyRegex, "₪") : result;
    };
  }

  // Carefully replace only text nodes (no innerHTML tampering)
  function updatePrices() {
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.nodeValue.includes("NIS")) {
        node.nodeValue = node.nodeValue.replace(currencyRegex, "₪");
      }
    }
  }

  // Run multiple times to catch late-loaded content
  updatePrices();
  setTimeout(updatePrices, 500);
  setTimeout(updatePrices, 1500);

  // Re-run on dynamic changes
  const observer = new MutationObserver(() => updatePrices());
  observer.observe(document.body, { childList: true, subtree: true });
});